import '../cursor.less';
import { useGetCursorIndex } from './use-get-cursor-index';

export const useRotateCursor = (rotate: number) => {
    const cursorIndex = useGetCursorIndex(rotate);

    const cursor = [
        'operate-rotate',
        'operate-rotate-rt',
        'operate-rotate-rt',
        'operate-rotate-rb',
        'operate-rotate-rb',
        'operate-rotate-lb',
        'operate-rotate-lb',
        'operate-rotate-lt',
    ];

    const getRotatedCursor = (offset: number) => {
        const rotatedIndex = (cursorIndex + offset) % cursor.length;
        return cursor[rotatedIndex];
    };

    const sideCursor = {
        LT: getRotatedCursor(7),
        RB: getRotatedCursor(3),
        LB: getRotatedCursor(5),
        RT: getRotatedCursor(1),
    };
    return { cursor: 'operate-rotate', sideCursor };
};
